/* artfunk-classes.js — ArtFunk Classes product page interactivity */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    initVariantCards();
    initFrameAddon();
    initStandaloneFrameBtn();
  }

  /* ── Variant card selection ───────────────────────────────── */
  function initVariantCards() {
    var cards = document.querySelectorAll('.af-variant-card');
    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (this.classList.contains('af-sold-out')) return;
        cards.forEach(function (c) { c.classList.remove('af-selected'); });
        this.classList.add('af-selected');
        var radio = this.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        showLocationGallery(this.dataset.location);

        // Sync hidden quantity from the newly selected variant's qty dropdown
        var wrapper = this.closest('.af-variant-wrapper');
        if (wrapper) {
          var sel = wrapper.querySelector('.af-qty-select');
          var hiddenQty = document.getElementById('af-hidden-qty');
          if (hiddenQty && sel) hiddenQty.value = sel.value;
        }
      });
    });

    // Initialise gallery for the default selected card
    var initial = document.querySelector('.af-variant-card.af-selected');
    if (initial) showLocationGallery(initial.dataset.location);
  }

  /* ── Location gallery ─────────────────────────────────────── */
  function showLocationGallery(location) {
    var galleries = document.querySelectorAll('.af-location-gallery');
    var titleEl   = document.getElementById('af-location-name');
    var shown     = false;

    galleries.forEach(function (g) {
      var match = location && g.dataset.location === location;
      g.style.display = match ? 'grid' : 'none';
      if (match) shown = true;
    });

    // Fallback to first gallery
    if (!shown && galleries.length > 0) {
      galleries[0].style.display = 'grid';
      if (titleEl) titleEl.textContent = galleries[0].dataset.location || 'San Francisco';
      return;
    }

    if (titleEl) titleEl.textContent = location || 'San Francisco';
  }

  /* ── Frame add-on ─────────────────────────────────────────── */
  function initFrameAddon() {
    var card = document.getElementById('af-frame-card');
    if (!card) return;
    var checkbox = card.querySelector('input[type="checkbox"]');
    if (checkbox) {
      checkbox.addEventListener('change', function () {
        toggleFrame(this.checked, card);
      });
    }
  }

  function toggleFrame(checked, card) {
    card.classList.toggle('af-checked', checked);

    var variantId = parseInt(card.dataset.variantId || '0', 10);

    if (variantId) {
      // Add/remove a separate frame product from the cart
      if (checked) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        }).catch(function () {});
      } else {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { [variantId]: 0 } })
        }).catch(function () {});
      }
    } else {
      // No separate product yet — store as a line item property on the class ticket
      var hiddenInput = document.getElementById('af-frame-property');
      if (!hiddenInput) {
        hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'properties[Frame]';
        hiddenInput.id = 'af-frame-property';
        var form = card.closest('.af-product-form-wrap');
        if (form) {
          var formEl = form.querySelector('form');
          if (formEl) formEl.appendChild(hiddenInput);
        }
      }
      hiddenInput.value = checked ? 'Yes (+$' + (card.dataset.price || '25') + ')' : '';
      hiddenInput.disabled = !checked;
    }
  }
  /* ── Standalone frame purchase ────────────────────────────── */
  function initStandaloneFrameBtn() {
    var btn  = document.querySelector('.af-frame-standalone-btn');
    var note = document.getElementById('af-frame-standalone-note');
    if (!btn) return;

    var variantId = parseInt(btn.dataset.variantId || '0', 10);
    if (!variantId) return;

    btn.addEventListener('click', function () {
      btn.disabled = true;
      btn.textContent = 'Adding\u2026';
      if (note) { note.textContent = ''; note.style.color = ''; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.ok ? res.json() : Promise.reject(res); })
        .then(function () {
          btn.textContent = '\u2713 Added to Cart';
          if (note) {
            note.textContent = 'Frame added \u2014 it will arrive with your class materials.';
            note.style.color = '#2a7a2a';
          }
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Add Frame to Cart';
          if (note) {
            note.textContent = 'Something went wrong \u2014 please try again.';
            note.style.color = '#a00';
          }
        });
    });
  }

})();
